import React, { useState } from 'react';

import { Box } from '@mui/material';

import LastMonthMembershipConfirmationStep from './LastMonthMembershipConfirmationStep';
import LastMonthMembershipSelectionStep from './LastMonthMembershipSelectionStep';
import {
  LastMonthMembershipAnnouncementCheckboxKey,
  LastMonthMembershipAnnouncementCheckboxState,
  LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_INITIAL_CHECKBOX_STATE,
  LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_LABELS,
} from './types';

interface LastMonthMembershipAnnouncementDialogProps {
  onConfirm: (selectedItems: string[]) => void;
}

const LastMonthMembershipAnnouncementDialog: React.FC<LastMonthMembershipAnnouncementDialogProps> = ({ onConfirm }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [checkboxes, setCheckboxes] = useState<LastMonthMembershipAnnouncementCheckboxState>(
    LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_INITIAL_CHECKBOX_STATE,
  );

  const handleCheckboxChange =
    (name: LastMonthMembershipAnnouncementCheckboxKey) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setCheckboxes({
        ...checkboxes,
        [name]: event.target.checked,
      });
    };

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  return (
    <Box sx={{ padding: 3, minWidth: 600 }}>
      {activeStep === 0 ? (
        <LastMonthMembershipSelectionStep
          checkboxes={checkboxes}
          labels={LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_LABELS}
          handleCheckboxChange={handleCheckboxChange}
          handleNext={handleNext}
        />
      ) : (
        <LastMonthMembershipConfirmationStep
          checkboxes={checkboxes}
          labels={LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_LABELS}
          handleBack={handleBack}
          onConfirm={onConfirm}
        />
      )}
    </Box>
  );
};

export default LastMonthMembershipAnnouncementDialog;
